export const formatCurrencyCompact = function(val, currencyOverride = 'USD') {
    if (val === undefined || val === null || isNaN(val)) return '-';
    const currency = currencyOverride;
    const num = Number(val);
    
    if (num >= 1000000) {
      return new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: currency
      }).format(num / 1000000) + 'M';
    } else if (num >= 1000) {
      return new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: currency
      }).format(num / 1000) + 'K';
    }
    
    return Number(val).toLocaleString(undefined, { 
      style: 'currency', 
      currency: currency
    });
};

export const formatNumberCompact = function(val) {
    if (val === undefined || val === null || isNaN(val)) return '-';
    const num = Number(val);
    
    if (num >= 1000000) {
      return new Intl.NumberFormat('en-US', { 
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num / 1000000) + 'M';
    } else if (num >= 1000) {
      return new Intl.NumberFormat('en-US', { 
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num / 1000) + 'K';
    }
    
    return Number(val).toLocaleString(undefined, { 
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
};

export const formatNumber = function(value){
  if (!isFinite(value)){
      return 1;
  }else if (isNaN(value)){
      return 0;
  }else if(value < 1000){
      return value;
  }else if(value < 10^6){
      return value/(10**3) + "K";
  }else if(value < 10^9){
      return value/(10**6) + "M";
  }else if(value < 10^12){
      return value/(10**9) + "B";
  }else if(value < 10^15){
      return value/(10**12) + "T";
  }else{
      return value;
  }
};